export const createGradient = (ctx, chartArea, colors) => {
    const {left, right, top, bottom} = chartArea;
    const gradient = ctx.createLinearGradient(left, top, right, bottom);
    
    const step = 1 / (colors.length - 1);
    colors.forEach((color, index) => {
      gradient.addColorStop(step * index, color);
    });
  
    return gradient;
  };